
import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import { Getter, namespace } from "vuex-class";
import { AreaNote } from "@/store/area-notes/types";
import { UserPermissions } from "@/store/types";
import moment from "moment";

const AreaNotes = namespace("areaNotes");

@Component
export default class AreaNotesTableItem extends Vue {
	@Prop({ default: {
		entry: "",
		groupId: 0,
		userName: "",
		created: "",
		requiresAcknowledgement: false,
		startFrom: "",
		endAt: ""
	}}) areaNote: AreaNote;
	@Prop({ type: Boolean, default: false}) hideUpdateControls: boolean;

	@Getter getPermissions: UserPermissions;
	@AreaNotes.Action deleteAreaNote: (noteId: number) => Promise<void>;
	@AreaNotes.Action startEditingNote: (note: AreaNote) => Promise<void>;
	@AreaNotes.Getter getAreaNoteToEdit: AreaNote;

	private areaNoteIdToDelete: number | null = null;
	private convertDate(value: Date): string {
		return value ? moment(value, "YYYY/MM/DD HH:mm").format("MM/DD/YYYY hh:mm A") : null;
	}

	private async deleteNote(): Promise<void> {
		await this.deleteAreaNote(this.areaNoteIdToDelete);
		this.areaNoteIdToDelete = null;
	}

	private async editNote(note: AreaNote): Promise<void> {
		await this.startEditingNote(note);
	}

	private hasPermissonsToEditNotes(): boolean {
		return this.getPermissions.canViewSiteSetup;
	}

	private showUpdateControls(): boolean {
		return (this.hasPermissonsToEditNotes() && !this.hideUpdateControls);
	}
}
